module.exports = {"610303001":"中山东路街道","610303002":"西关街道","610303003":"中山西路街道","610303004":"群众路街道","610303006":"东风路街道","610303007":"十里铺街道","610303008":"卧龙寺街道","610303100":"陈仓镇","610303101":"蟠龙镇","610303102":"金河镇","610303103":"硖石镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610303.json
// module id = 2931
// module chunks = 0